import { zCustom } from '@nucleus/lib-shape';
import { zKey } from '@nucleus/ncu-key-prefix';
import { ISO8601Schema } from '@nucleus/src-platform/data';
import * as yup from 'yup';
import { z } from 'zod';
import { PublishableEngineSchemaDeprecated } from './PublishableEngine';
import { PublishableEntitySchemaDeprecated } from './PublishableEntity';

type PublishableVersionBase = z.infer<typeof PublishableVersionBaseSchema>;

const PublishableVersionBaseSchema = z.object({
  id: zKey.prefixedKey(),
  createdAt: zCustom.iso(),
  createdBy: z.string().trim(),
  updatedAt: zCustom.iso(),
  updatedBy: z.string().trim(),
});

/**
 * @deprecated this schema is deprecated and will be removed in the future
 */
const PublishableVersionBaseSchemaDeprecated: yup.SchemaOf<PublishableVersionBase> = yup.object({
  id: yup.string().required(),
  createdAt: ISO8601Schema.required(),
  createdBy: yup.string().required(),
  updatedAt: ISO8601Schema.required(),
  updatedBy: yup.string().required(),
});

export type PublishableVersion = z.infer<typeof PublishableVersionSchema>;

export const PublishableVersionSchema = PublishableVersionBaseSchema.extend({
  name: z.string().optional(),
  engineId: zKey.prefixedKey(),
  entityId: zKey.prefixedKey(),
  entityCreatedAt: zCustom.iso(),
  latestRevisionAt: zCustom.iso(),
  latestRevisionBy: z.string().trim(),
  latestRevisionPublishedAt: zCustom.iso().optional(),
  latestRevisionPublishedBy: z.string().trim().optional(),
  latestRevisionIndex: z.number().min(1),
  latestRevisionPublishedIndex: z.number().min(1).optional(),
});

/**
 * @deprecated this schema is deprecated and will be removed in the future
 */
export const PublishableVersionSchemaDeprecated: yup.SchemaOf<PublishableVersion> =
  PublishableVersionBaseSchemaDeprecated.shape({
    name: yup.string().optional(),
    engineId: PublishableEngineSchemaDeprecated.fields.id.required(),
    entityId: PublishableEntitySchemaDeprecated.fields.id.required(),
    entityCreatedAt: PublishableEntitySchemaDeprecated.fields.createdAt.required(),
    latestRevisionAt: ISO8601Schema.required(),
    latestRevisionBy: yup.string().required(),
    latestRevisionPublishedAt: ISO8601Schema,
    latestRevisionPublishedBy: yup.string(),
    latestRevisionIndex: yup.number().min(1).required(),
    latestRevisionPublishedIndex: yup.number().min(1),
  });

export type PublishableVersionLock = z.infer<typeof PublishableVersionLockSchema>;

export const PublishableVersionLockSchema = PublishableVersionBaseSchema.extend({
  entityId: zKey.prefixedKey(),
  ownerId: z.string().trim(),
  ownerName: z.string().optional(),
  ownerEmail: z.string().optional(),
  expiresAt: zCustom.iso(),
});

/**
 * @deprecated this schema is deprecated and will be removed in the future
 */
export const PublishableVersionLockSchemaDeprecated: yup.SchemaOf<PublishableVersionLock> =
  PublishableVersionBaseSchemaDeprecated.shape({
    entityId: PublishableEntitySchemaDeprecated.fields.id.required(),
    ownerId: yup.string().required(),
    ownerName: yup.string().optional(),
    ownerEmail: yup.string().optional(),
    expiresAt: ISO8601Schema.required(),
  });
